import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12.037",
  r: "12",
  fill: "#2D2D33"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m13.153 10.965 5.1-5.928h-1.209l-4.428 5.147-3.537-5.147H5l5.348 7.784L5 19.037h1.209l4.676-5.435 3.735 5.435h4.08l-5.547-8.072Zm-1.656 1.924-.541-.775-4.312-6.167H8.5l3.48 4.977.542.775 4.523 6.47h-1.857l-3.69-5.28Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }